import { CircularProgress } from "@mui/material";
import "./styles.scss";

export const OverlayLoader = ({
  loadingText = "Loading...",
}: {
  loadingText?: string;
}) => {
  return (
    <div className="loader-overlay">
      <div className="loader-overlay-content">
        <CircularProgress size={40} sx={{ color: '#00A06D' }} />
        <h4>{loadingText}</h4>
      </div>
    </div>
  );
};
